<div wfdssInputAutoFocus tabindex="0" style="width: 360px;">
<h2 wfdssInputAutoFocus tabindex="0" mat-dialog-title>{{data.title}}</h2>
</div>
<mat-dialog-content>
    <div class="content-container" tabindex="0">
        <span style="color: black;">{{ data.message }} </span>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="button-container">
        <button *ngIf="data.primaryButton" class="primary-button btn1" (click) ="onClose('pdf')" tabindex="0">
            {{ data.primaryButton }}
        </button>
        <button *ngIf="data.secondaryButton" [disabled]="data.disableSecondaryBtn" class="primary-button btn2" (click) ="onClose('sign')" tabindex="0">
            {{ data.secondaryButton }}
        </button>
        <button *ngIf="data.cancelButton" class="secondary-button" [mat-dialog-close]="false" tabindex="0">
            {{ data.cancelButton }}
        </button>
    </div>
</mat-dialog-actions>
